<template>
  <Layout ref="pageRef">
    <template v-slot:navigation>
      <Navigation :showMenu="true">
        <template v-slot:title>
          <router-link :to="`/categories/${categoryKey}`">
            <div class="navigation-title">{{ $t(caption) }}</div>
          </router-link>
        </template>
      </Navigation>
    </template>
    <template v-slot:content>
      <div class="content">
        <Caution v-if="!cautionViewed" :onOk="onUnderstand" />
        <div class="cover" :class="{ active: cautionViewed }">
          <div>
            <div class="box-image">
              <img
                :srcset="`${boxCover.image.pc} 1024w, ${boxCover.image.mobile} 360w`"
                :src="boxCover.image.pc"
              />
            </div>
          </div>
          <div class="box-list-item__description">
            <!-- 
            need to compoare box between dezeenbox
            dezeen has no level 
            so add ':class="[boxCover.level? ' ':'dezeen']' to compare-->
            <div
              ref="itemDescription"
              :class="[IsDeezenBox == -1 ? '' : 'mobile_height']"
            >
              <div
                v-if="$t(boxCover.title).includes('\n')"
                class="box-list-item__title primary-text-color"
                v-html="
                  boxCover.text
                    ? $t(boxCover.title).replace(/(?:\r\n|\r|\n)/g, '<br/>') +
                      '&nbsp' +
                      boxCover.text
                    : $t(boxCover.title).replace(/(?:\r\n|\r|\n)/g, '<br/>')
                "
              ></div>
              <div v-else class="box-list-item__title primary-text-color">
                {{ $t(boxCover.title) }}&nbsp;
                {{ boxCover.text ? boxCover.text : "" }}
              </div>
              <div v-if="boxCover.level" class="box-list-item__star">
                <img
                  v-for="i in [1, 2, 3, 4, 5]"
                  :src="
                    i <= boxCover.level
                      ? require('../style/BoxList/assets/star_pc.png')
                      : require('../style/BoxList/assets/star_pc_empty.png')
                  "
                  :key="i"
                />
              </div>
              <div
                v-if="boxCover.level"
                class="box-list-item__minutes secondary-text-color"
              >
                <img class="clock" src="../../assets/icons/clock-pc.png" />
                {{ boxCover.minutes }} {{ $t("ProductPage.mins") }}
              </div>
              <div class="box-list-item__inches secondary-text-color">
                <span
                  v-if="
                    boxCover.allowInches.length === 1 ||
                    boxCover.allowInches.length !== filterList.length
                  "
                >
                  <span v-for="(inch, i) in boxCover.allowInches" :key="i">
                    {{ inch }}
                    <span v-if="i !== boxCover.allowInches.length - 1">/</span>
                  </span>
                </span>
                <!-- {{filterList.length}} -->
                <span v-if="branchCategory == true">
                <span
                  v-if="
                    boxCover.allowInches.length !== 1 &&
                    boxCover.allowInches.length === filterList.length
                  "
                  >{{ $t("ProductPage.allBoxSize") }}</span
                >
                <span v-else-if="boxCover.allowInches.length === 1">{{
                  $t("ProductPage.in")
                }}</span>
                <span v-else-if="boxCover.allowInches.length !== 1">{{
                  $t("ProductPage.in")
                }}</span></span>
                <span v-else>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <overdrive id="test" :easing="easing" :duration="600">
          <img :src="images[1]" />
        </overdrive>-->
        <!-- v-if="box !== undefined" -->
        <BoxDetail
          v-if="box !== undefined && coverLoad && cautionViewed"
          :text="{
            instructions: $t('DetailGuidePage.instructions'),
            prepare: $t('DetailGuidePage.prepare'),
            design1: $t('DetailGuidePage.LetsDesign'),
            design2: $t('DetailGuidePage.drawParts'),
            designWarning1: $t('DetailGuidePage.note1'),
            designWarning2: $t('DetailGuidePage.note2'),
            designWarning3: $t('DetailGuidePage.numberSpace'),
            cutAndAssemble1: $t('DetailGuidePage.cutAndAssemble'),
            cutAndAssemble2: $t('DetailGuidePage.beCareful'),
            cutAndAssemble3: $t('DetailGuidePage.cutOutParts'),
            cutAndAssemble4: $t('DetailGuidePage.assemble'),
            fold1: $t('DetailGuidePage.Assemblyguide'),
            fold2:$t('DetailGuidePage.foldGuideDezeen'),
            fold3: $t('DetailGuidePage.foldGuide'),
            glue: $t('DetailGuidePage.glue'),
            cable: $t('DetailGuidePage.cable'),
            complete: $t('DetailGuidePage.done'),
            backButton: $t('DetailGuidePage.goBack'),
          }"
          :prepareSequenceImages="box.prepareSequenceImages"
          :designSliderImage="box.designSliderImage"
          :designImageList="box.designImageList"
          :cutOutPartsImage="box.cutOutPartsImage"
          :cutOutPartsImage2="box.cutOutPartsImage2"
          :cutOutPartsImage3="box.cutOutPartsImage3"
          :cutOutPartsFoldImage="box.cutOutPartsFoldImage"
          :cutOutPartsFoldImage2="box.cutOutPartsFoldImage2"
          :gluePartsImage="box.gluePartsImage"
          :cablePartsImage="box.cablePartsImage"
          :assembleSequenceImages="box.assembleSequenceImages"
          :completeImage="box.completeImage"
          :completeImagePc="box.completeImagePc"
          :categoryKey="categoryKey"
        />
      </div>
    </template>
    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>
import Navigation from "../style/Navigation.vue";
import Footer from "../style/Footer.vue";
import Layout from "../style/Layout.vue";
import BoxDetail from "../style/BoxDetail/index.vue";
import { Models, categories } from "@/models/categories";
import { ModelKey } from "@/models/categories/serif";
import { OverdriveKey } from "@/models/overdrive/Category_Box";
import * as easing from "eases/quart-in-out";
import { CategoryLists } from "@/models/CategoryKey";
import OnLoadImage from "../mixin/OnLoadImage";
import Caution from "../style/Caution";

export default {
  mixins: [OnLoadImage],
  components: {
    Navigation,
    Footer,
    Layout,
    BoxDetail,
    Caution,
  },
  props: {
    boxKey: {
      type: String,
      default: () => ModelKey.Serif01,
    },
    categoryKey: {
      type: String,
      default: () => CategoryLists.Lifestyle.list.Serif,
    },
    boxCover: {
      type: Object,
      default() {
        return (
          categories[this.categoryKey].box.list.find(
            (v) => v.key === this.boxKey
          ) || //if undefined search at dezeenBox.
          categories[this.categoryKey].dezeenBox.list.find(
            (v) => v.key === this.boxKey
          ) || //if undefined search at worldcup.
          categories[this.categoryKey].worldcup.list.find(
            (v) => v.key === this.boxKey
          ) || //if undefined search at disney.
          categories[this.categoryKey].disney.list.find(
            (v) => v.key === this.boxKey
          )
        );
      },
    },
  },
  async created() {
    this.caption = categories[this.categoryKey].cover.caption;
    window.scrollTo(0, 0);
    const asyncModel = Models[this.boxKey];

    // need to confirm dezeen box
    const dezeenList = categories[this.categoryKey].dezeenBox.list || null;

    dezeenList === null
      ? -1
      : (this.IsDeezenBox = dezeenList
          .map((box) => box.key)
          .indexOf(this.boxCover.key));
    
     // need to confirm worldcup box
    const worldcupList = categories[this.categoryKey].worldcup.list || null;

    worldcupList === null
      ? -1
      : (this.IsworldcupBox = worldcupList
          .map((box) => box.key)
          .indexOf(this.boxCover.key));
    
     // need to confirm disney box
    const disneyList = categories[this.categoryKey].disney.list || null;

    disneyList === null
      ? -1
      : (this.IsDisneyBox = disneyList
          .map((box) => box.key)
          .indexOf(this.boxCover.key));
    // this.boxList =
    //   this.IsDeezenBox >= 0
    //     ? categories[this.categoryKey].dezeenBox.list
    //     : categories[this.categoryKey].box.list;

    if( this.IsDeezenBox >= 0 )
    {
        categories[this.categoryKey].dezeenBox.list 
    }
    else if(this.IsworldcupBox >= 0)
    {
        categories[this.categoryKey].worldcup.list;
    }
    else if(this.IsDisneyBox >= 0)
    {
       categories[this.categoryKey].disney.list;
    }
    else{
        categories[this.categoryKey].box.list;
    }
    
    try {
      this.box = (await asyncModel()).default;
      await this.loadImages([
        this.boxCover.image.pc,
        this.boxCover.image.mobile,
      ]);

      this.coverLoad = true;
      this.$forceUpdate();
      this.cautionViewed = localStorage.getItem("cautionUnderstand");
    } catch (e) {
      // catch error and push not found page
      console.log(e);
      this.$router.replace({ path: "/404" });
    }
  },
  data() {
    return {
      caption: undefined,
      overdrive: OverdriveKey,
      // boxKey: undefined,
      box: null,
      boxList: [],
      easing,
      IsDeezenBox: 0,
      IsworldcupBox:0,
      IsDisneyBox:0,
      coverLoad: false,
      cautionViewed: true,
    };
  },
  methods: {
    onUnderstand() {
      localStorage.setItem("cautionUnderstand", true);
      this.cautionViewed = true;
    },
  },
  computed: {
    branchCategory(){
      if(this.categoryKey == 'BespokeJet')
          return false;
      else if(this.categoryKey == 'BespokeJetStation')
          return false;
      else if(this.categoryKey == 'BespokeJetNCleanStation')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir53')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir70')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir106')
          return false;
      else if(this.categoryKey == 'bespoke_cubeAir123')
          return false;
      else if(this.categoryKey == 'Bespoke_slim')
          return false;   
      else if(this.categoryKey =="TheFreestyle")
          return false; 
      else if(this.categoryKey =="BespokeSlimCleanStation")
          return false; 
      else if(this.categoryKey =="JetCleanStation")
          return false; 
      else if(this.categoryKey =="BlueSky")
          return false; 
      else if(this.categoryKey =="BlueSky3000")
          return false; 
      else if(this.categoryKey =="BlueSky3100")
          return false;
      else if(this.categoryKey =="BlueSky5000")
          return false; 
      else if(this.categoryKey =="Soundtower")
          return false;  
      else if(this.categoryKey =="Soundbar")
          return false;
      else if(this.categoryKey =="BespokeJetbot")
          return false;  
      else if(this.categoryKey =="BespokeJetbotPlus")
          return false;  
      else if(this.categoryKey =="BespokeJetbotAI")
          return false;  
      else if(this.categoryKey =="LATIN")
          return false;  
      else if(this.categoryKey =="LATIN10")
          return false;    
      else if(this.categoryKey =="MIRROR")
          return false;  
      else if(this.categoryKey =="MW5100J")
          return false;  
      else if(this.categoryKey =="STENA")
          return false;  
      else
          return  true;
    },
    filterList() {
      if (this.boxList === undefined || this.boxList.length === 0) {
        return [];
      }
      const targets = categories[this.categoryKey].box.list.reduce(
        (pre, cur) => {
          cur.allowInches.forEach((v) => {
            pre[v] = true;
          });
          return pre;
        },
        {}
      );
      return [...Object.keys(targets)];
    },
  },
   mounted: {
    $nextTick(){
        window.scrollTo(0,0);  
    }
        
  },
};
</script>

<style scoped>
.navigation-title {
  position: relative;
  padding-left: 15px;
  line-height: 0.87;
  font-weight: 700;
}
.navigation-title::after {
  width: 5px;
  height: 5px;
  content: " ";
  position: absolute;
  left: 0;
  transform: translateY(-50%) rotate(-45deg);
  border-left: 2px solid #f5f5f5;
  border-top: 2px solid #f5f5f5;
  top: 40%;
}
.background {
  /* height: 300px; */
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  z-index: 0;
  background-color: black;
  top: 0;
  left: 0;
}
.cover {
  position: relative;
  max-width: 1200px;
  margin: auto;
  box-sizing: content-box;
  display: flex;
  justify-content: center;
  z-index: 2;
  align-items: center;
}
.box-image {
  margin: auto;
}
.content {
  margin-top: 97px;
  /* background-color: #111111; */
  text-align: left;
  min-height: 100vh;
}
/* .content {
  display: flex;
  justify-content: center;
} */
.box-image {
  /* display: inline-block; */
  z-index: 1;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 0;
  /* margin-top: 30px; */
}
.box-image img {
  width: 200px;
  height: 200px;
  padding: 50px;
  object-fit: contain;
  /* max-height: 300px; */
}

.box-image.dezeen img {
  width: 200px;
  height: 200px;
  padding: 50px;
  /* max-height: 300px; */
}
.cover {
  display: flex;
  flex-direction: column-reverse;
  padding: 0 20px;
  /* height: calc(70vh - constant(safe-area-inset-bottom));
  height: calc(70vh - env(safe-area-inset-bottom)); */
  transition: opacity 0.3s;
  opacity: 0;
}
.cover.active {
  opacity: 1;
}
.box-list-item__description {
  padding-left: 56px;
  box-sizing: border-box;
  /* align-self: flex-start; */
  width: 340px;
}
.box-list-item__title {
  line-height: 1.1;
  font-size: 1.5rem;
  font-weight: 700;
}

.box-list-item__minutes,
.box-list-item__inches {
  font-size: 1.33rem;
  font-weight: 500;
  /* line-height: 1; */
}
.box-list-item__star {
  margin-top: 12px;
  margin-bottom: 12px;
}
.box-list-item__star img {
  width: 20px;
}
.clock {
  width: 10px;
}
@media (min-width: 720px) {
  .content {
    margin-top: 300px;
  }

  .cover {
    display: flex;
    flex-direction: row;
    padding: 0;
    box-sizing: border-box;
    max-width: 1200px;
    padding-left: 8.59vw;
    margin-left: auto;
    margin-right: auto;
    justify-content: flex-start;
    margin-bottom: 239px;
  }
  .box-image {
    margin-bottom: 0;
    padding: 0;
    margin-top: 30px;
  }
  .box-image img {
    width: 300px;
    height: 300px;
    padding: 60px;
  }
  .box-image.dezeen img {
    width: 300px;
    height: 300px;
    padding: 60px;
    /* max-height: 300px; */
  }
  .box-list-item__description {
    align-items: center;
    display: flex;
    margin-left: 5.312vw;
    padding-left: 0;
  }
  .box-list-item__title {
    font-size: 32px;
    line-height: 1.1;
  }
  .box-list-item__star img {
    width: 30px;
    margin-right: 8px;
  }
  .box-list-item__minutes,
  .box-list-item__inches {
    font-size: 28px;
    font-weight: 500;
    /* line-height: 1; */
  }
}
@media (max-width: 500px) {
  .mobile_height {
    height: 103px;
  }
}
@media (min-width: 1024px) {
  .navigation-title {
    padding-left: 35px;
  }
  .navigation-title::after {
    width: 10px;
    height: 10px;
    content: " ";
    position: absolute;
    left: 0;
    transform: translateY(-50%) rotate(-45deg);
    border-left: 4px solid #f5f5f5;
    border-top: 4px solid #f5f5f5;
    top: 50%;
  }
  .clock {
    width: auto;
  }
}
@media (min-width: 1920px) {
  .box-list-item__description {
    margin-left: 102px;
  }
}
</style>
